import Component from './Component'
import { connect } from 'react-redux';
import { mapDispatchToProps } from '@containers/App/user/auth/form/signIn/redux';
import withLocale from '@modules/translate/withLocale';

export default connect(null, mapDispatchToProps)(withLocale(Component))
